import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { LocalStorageClass } from '../helpers/local-storage-helper';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  private readonly router = inject(Router);

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const token = LocalStorageClass.retrieveTokenFromStorage();

    if (token?.length) {
      return true;
    }

    // A registered user awaiting approval holds only a tempRegistrationToken.
    // Redirect straight to the waiting page with a UrlTree — going via /login
    // would let LoginPageGuard bounce again and race the reload below, causing
    // an infinite / <-> waiting-for-approval loop.
    if (LocalStorageClass.getTempRegistrationToken()?.length) {
      return this.router.parseUrl('/login/waiting-for-approval');
    }

    // Preserve the deep-link target so we can return to it after login.
    // (Survives the navigate-to-login + reload below via localStorage.)
    if (state.url && !state.url.startsWith('/login')) {
      LocalStorageClass.setReturnUrl(state.url);
    }

    this.router.navigate(['login']).then(() => {
      window.location.reload();
    });

    return false;
  }
}
